import { AdyenCheckout, CoreConfiguration, ICore } from '@adyen/adyen-web-v6';

export async function adyenCheckout({ configuration } : { configuration: CoreConfiguration }): Promise<ICore> {
  return AdyenCheckout(configuration);
}
